<template>
  <section>
    <el-form :rules="loginRules" ref="loginForm" :model="loginForm" label-width="0">
      <el-form-item prop="mobile">
        <el-input
          size="medium "
          @keyup.enter.native="handleLogin"
          v-model="loginForm.mobile"
          auto-complete="off"
          placeholder="请输入手机号码"
          maxlength="11"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          size="medium"
          @keyup.enter.native="handleLogin"
          :type="passwordType"
          v-model.trim="loginForm.password"
          auto-complete="off"
          placeholder="请输入密码"
          maxlength="6"
        ></el-input>
      </el-form-item>
      <p class="text-gray text-right h6 mt2">
        <router-link target="a" to="/passWord-find">找回密码</router-link>
      </p>
      <el-form-item class="mt6">
        <el-button type="primary" @click.native.prevent="handleLogin" class="btn-login" :disabled="loginFlag">登录</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import { phoneNo } from "@/common/regex";
import {mapActions} from 'vuex'
let msgBox = null;
export default {
  data() {
    return {
      passwordType: "password",
      loginFlag:false,
      loginForm: {
        mobile: "",
        password: ""
      },
      loginRules: {
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { pattern: phoneNo, message: "请输入正确的手机号码", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 6, message: "请输入六位数密码", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    ...mapActions({
      loginPsw: 'user/LOGINPASSWORD',
    }),
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          let params = {
            ...this.loginForm
          };
          //const res = await this.$store.dispatch(`user/LOGINPASSWORD`,params);
           const res = await this.loginPsw(params);
          if (res.code === 200 && res.data) {
            this.loginFlag = true
            let self = this;
            self.$router.push("/home");
            // this.$message.success("登录成功").onClose = () => {
            //   self.$router.push("/home");
            // };
          }
        }
      });
    },
    clearValidate() {
      this.$refs.loginForm.resetFields();
    }
  }
};
</script>
